module.exports = __webpack_public_path__ + "img/ic_24_social_whatsapp.7a82294d.svg";